import { Component } from '@angular/core';

@Component({
  selector: 'app-open8-info-component',
  imports: [],
  templateUrl: './open8-info-component.html',
  styleUrl: './open8-info-component.scss'
})
export class Open8InfoComponent {

}
